import React, { FC } from 'react';

import { Row } from '@tanstack/react-table';

import { StatsRecord } from '~/views/components/statsTable/utils/types';

type Props = {
    row: Row<StatsRecord>;
};

export const getPlayerUrl = (playerId: number): string => {
    const languagePath = window.__SITE_LANGUAGE_CODE__ === 'en' ? '/' : `/${window.__SITE_LANGUAGE_CODE__}/`;
    return `https://${window.location.host}${languagePath}player/${playerId}`;
};

const PlayerNameCell: FC<Props> = ({ row }) => {
    const playerId = row.original.playerId as number;
    const playerName = (row.original.skaterFullName || row.original.goalieFullName) as string;
    return (
        <div>
            <a href={getPlayerUrl(playerId)}>{playerName}</a>
        </div>
    );
};

export default React.memo(PlayerNameCell);
